import { Alert, Button, Stack } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { t } from "i18next";
import { useStores } from "../../../../shared/stores/RootStore";

const MultiSelectionWarningBase: React.FC = () => {
  const { osaNodeStore } = useStores();

  const nNodesSelected = osaNodeStore.multiSelectedIds.size;
  if (!nNodesSelected) return null;

  return (
    <Alert.Root status="info" flexShrink={0} borderRadius={0}>
      <Alert.Indicator />
      <Stack gap={0} flexGrow={1}>
        <Alert.Title>
          {`${t(`shared:nodes`, {
            count: nNodesSelected,
          })} are selected`}
        </Alert.Title>
        <Alert.Description fontSize="xs">
          Any attribute changes will be reflected in your selection
        </Alert.Description>
      </Stack>
      <Button
        size="sm"
        fontSize={"sm"}
        onClick={() => osaNodeStore.setMultiSelectedIds(new Set())}
      >
        Clear selection
      </Button>
    </Alert.Root>
  );
};

export const MultiSelectionWarning = observer(MultiSelectionWarningBase);
